import { AutocompleteInputChangeReason } from '@mui/material/Autocomplete';
import { useState } from 'react';
import useDebounce from '../../../../../hooks/useDebounce/useDebounce';

interface UseAutocompleteSearchParams {
  delay?: number;
}

const useAutocompleteSearch = ({ delay = 300 }: UseAutocompleteSearchParams = {}) => {
  const [inputValue, setInputValue] = useState('');
  const searchTerm = useDebounce(inputValue, delay);

  const onInputChange = (
    _event: React.SyntheticEvent,
    value: string,
    _reason: AutocompleteInputChangeReason,
  ) => {
    setInputValue(value);
  };

  return { inputValue, searchTerm, onInputChange };
};

export default useAutocompleteSearch;
